import React from 'react';
import { isNum, colorAt } from './chartUtils';
import './charts.css';

/** Donut over segments [{key,label,value,color?}] with an optional centre label. */
const Donut = ({ segments, centerLabel, label, size = 120, testId }) => {
  const segs = (segments || []).filter((s) => s && isNum(s.value) && s.value > 0);
  const sum = segs.reduce((a, s) => a + s.value, 0);
  if (sum <= 0) return null;
  const r = 44;
  const c = 2 * Math.PI * r;
  const aria = `${label || 'Share'}: ${segs.map((s) => `${s.label} ${s.value}`).join(', ')}`;
  let offset = 0;
  return (
    <figure className="pl-chart-gauge" style={{ margin: 0 }} data-testid={testId}>
      <svg className="pl-chart" role="img" aria-label={aria} viewBox="0 0 120 120" width={size} height={size}>
        <title>{aria}</title>
        <desc>Donut chart; the legend lists every value.</desc>
        {segs.map((s, i) => {
          const len = (s.value / sum) * c;
          const node = <circle key={s.key} cx="60" cy="60" r={r} fill="none" stroke={s.color || colorAt(i)} strokeWidth="12" strokeDasharray={`${Math.max(len - 2, 0)} ${c}`} strokeDashoffset={-offset} transform="rotate(-90 60 60)" />;
          offset += len;
          return node;
        })}
        {centerLabel != null && <text x="60" y="66" textAnchor="middle" fontSize="20" fontWeight="600">{centerLabel}</text>}
      </svg>
      <ul className="pl-chart-legend">
        {segs.map((s, i) => (
          <li key={s.key}><span className="pl-chart-swatch" style={{ background: s.color || colorAt(i) }} />{s.label} <span className="pl-chart-legend__n">{s.value}</span></li>
        ))}
      </ul>
    </figure>
  );
};

export default Donut;
